import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import visitTracker from '@/lib/visitTracker';

/**
 * Hook pour compter les visites automatiquement.
 * Met à jour le compteur local de visites uniques par session — aucun appel
 * réseau : les métriques distantes sont émises par usePageViewTracker.
 */
export function useVisitCounter() {
  useEffect(() => {
    // Track la visite au chargement du composant (synchrone, localStorage)
    try {
      visitTracker.init();
    } catch (error) {
      console.warn('Erreur lors du tracking de la visite:', error);
    }
  }, []); // S'exécute une seule fois au montage
}

/**
 * Hook pour tracker une vue de page à CHAQUE navigation SPA.
 * Indépendant de la dé-dup de session : un POST est émis pour chaque
 * changement de pathname afin d'alimenter PageViews / ViewsByPath.
 * Doit être appelé à l'intérieur du Router (utilise useLocation).
 */
export function usePageViewTracker() {
  const location = useLocation();
  // Mémorise le referrer interne (chemin précédent) pour les navigations SPA.
  const previousPathRef = useRef(null);

  useEffect(() => {
    // Au premier rendu, le referrer est celui du document (entrée externe);
    // ensuite c'est le chemin interne précédent.
    const referrer = previousPathRef.current || document.referrer || 'direct';

    visitTracker.trackPageView(location.pathname, referrer).catch((error) => {
      console.warn('Erreur lors du tracking de la vue de page:', error);
    });

    previousPathRef.current = location.pathname;
  }, [location.pathname]); // Ré-exécuté à chaque changement de chemin
}




